<div class="page-footer">
        <div style="display: flex; flex-direction: row;"><div style="padding-top: 0.23rem; margin-right: 0.3rem;">&copy;</div>2026</div>
        <div>Edita Pattová</div>
        <div><a href="mailto:e.pattova@gmail.com">e.pattova{{'@'}}gmail.com</a></div>
</div>
